import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useUrlToken, Shell } from "@/pages/VerifyEmail";

export default function ResetPassword() {
  usePageMeta({ title: "Choose a new password - The Cardlight", description: "Reset your password for The Cardlight.", path: "/auth/reset" });
  const token = useUrlToken();
  const { login } = useAuth();
  const [password, setPassword] = useState("");
  const [state, setState] = useState({ busy: false, error: "", done: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, error: "", done: "" });
    try {
      const res = await api.post("/auth/email/reset", { token, password });
      setState({ busy: false, error: "", done: res.data.message });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setState({ busy: false, error: typeof d === "string" ? d : "Please use at least 8 characters.", done: "" });
    }
  };

  if (state.done) {
    return (
      <Shell testid="reset-page" title="Password changed">
        <p data-testid="reset-done">{state.done}</p>
        <button onClick={login} className="rounded-full bg-[#D9A441] px-5 py-2.5 font-medium text-[#0B0C15]" data-testid="reset-signin-btn">Sign in</button>
      </Shell>
    );
  }
  return (
    <Shell testid="reset-page" title="Choose a new password">
      <form onSubmit={submit} className="space-y-3 text-left">
        <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (at least 8 characters)" autoComplete="new-password" data-testid="reset-password-input" className="w-full rounded-lg border border-[#D9A441]/25 bg-[#0B0C15]/60 px-3.5 py-2.5 text-sm text-[#F8F3E6] focus:border-[#D9A441]/70 focus:outline-none" />
        {state.error && <p role="alert" className="text-sm text-[#E8896B]" data-testid="reset-error">{state.error}</p>}
        <button type="submit" disabled={state.busy || !token} data-testid="reset-submit-btn" className="w-full rounded-full bg-[#D9A441] px-5 py-2.5 text-sm font-medium text-[#0B0C15] disabled:opacity-60">
          {state.busy ? "One moment…" : "Save new password"}
        </button>
      </form>
    </Shell>
  );
}
